import { type Component } from "solid-js";
import { LoaderCircle } from "lucide-solid";

/** Simple spinning loader icon. */
const Spinner: Component<{ size?: number; class?: string }> = (props) => {
  return (
    <LoaderCircle
      size={props.size ?? 20}
      class={`animate-spin text-muted-foreground ${props.class ?? ""}`}
    />
  );
};

export default Spinner;
